import { createServerFn } from "@tanstack/react-start";
import { resolveExistingViewerRef } from "@/lib/core/auth";
import {
    type RecordExperimentExposureInput,
    recordExperimentExposureInputSchema,
} from "./record-experiment-exposure.contract.ts";
import { assignSharedExperimentArm } from "./experiment-arms.server.ts";

export const recordExperimentExposure = createServerFn({ method: "POST" })
    .inputValidator((data: RecordExperimentExposureInput) =>
        recordExperimentExposureInputSchema.parse(data),
    )
    .handler(async ({ data }) => {
        const viewer = await resolveExistingViewerRef();
        if (!viewer) return null;
        return assignSharedExperimentArm({
            name: data.name,
            subjectId: viewer.viewerId,
        });
    });
